import React from "react";
import { ChipPanel } from "../Chip";
import { ToggleChip } from "../Chip";


export function SafeFlagSelector (props: {
    allowedFlags:readonly string[],
    selectedFlags:string[],
    colorMode?:'colorHash' | 'colorIndex',
    disabled?:boolean,
    onChange: (newFlags:string[]) => void
}): JSX.Element
{
    function handleClickFlag (flag:string, selected:boolean)
    {
        const validSelected = props.selectedFlags.filter(f => props.allowedFlags.includes(f));

        const newFlags = selected 
            ? [...validSelected, flag]
            : validSelected.filter(f => f !== flag);        

        props.onChange(newFlags);
    }


    return (
        <ChipPanel>
            {props.allowedFlags.map(a => a).sort((a,b) => a.localeCompare(b)).map((flag,index) => {
                
                const selected = props.selectedFlags.includes(flag);

                return (
                    <ToggleChip key={flag} 
                        selectedStyle={
                            props.colorMode === 'colorIndex' ? { colorIndex: index } : { colorHash: flag }
                        }
                        selected={selected}
                        
                        disabled={props.disabled} 
                        onClick={() => handleClickFlag(flag, !selected)}>{flag}
                    </ToggleChip>
                );
            })}
        </ChipPanel>
    );
}